import { getSpecialtyTranscript } from '@/pages/api/scribeDemoApi';
import { type SpecialtyTranscriptResponse } from '@/types';
import { DEFAULT_LOCALE } from '@/utils/i18n/supportedLocales';
import { useQuery } from '@tanstack/react-query';

export const GET_SPECIALTY_TRANSCRIPT = 'getSpecialtyTranscript';

export function useQuerySpecialtyTranscript(
  specialtyName: string | undefined,
  locale: string = DEFAULT_LOCALE
) {
  return useQuery<SpecialtyTranscriptResponse>({
    queryKey: [GET_SPECIALTY_TRANSCRIPT, specialtyName, locale],
    queryFn: async () => {
      const { data } = await getSpecialtyTranscript(specialtyName!, locale);
      return data;
    },
    enabled: !!specialtyName,
  });
}
